import { createFileRoute } from "@tanstack/react-router";
import { ClientReportsPage } from "@/features/clientreport/ClientReportsPage";

export const Route = createFileRoute("/_app/reports/clients/")({ component: ClientReportsPage });
